import React from 'react';
import { useNavigate } from "react-router-dom";
import { Settings, BookOpen, SlidersHorizontal, Bot, Edit3, FileDown, Upload } from "lucide-react";
import AppHeader from "./components/AppHeader";

const steps = [
  {
    title: 'Choose Your Course & Module',
    description:
      'Begin by selecting the subject and topic you want questions for. This ensures the content is aligned with your curriculum.',
  },
  {
    title: 'Customize Your Question Set',
    description:
      'Decide how many questions you need, and set preferences like difficulty level or the Multiple Choice Questions and true-false ratio.',
  },
  {
    title: 'DeepToast generates questions',
    description:
      'DeepToast AI creates tailored questions using advanced proprietary models that understand your subject, course content and learning objectives',
  },
  {
    title: 'Refine with Ease',
    description:
      'Use our review interface to accept, edit, or reject each question. Customize wording, format, or options as needed.',
  },
  {
    title: 'Export in Your Format',
    description:
      'Download your finalized questions in multiple formats — ready for LMS upload, print, or sharing with students.',
  },
  {
    title: 'Import into Canvas',
    description:
      'We provide step-by-step guidance to help you upload your questions into the Canvas Question Bank for seamless integration.',
  },
];

// Icon mapping aligned with steps above
const stepIcons = [BookOpen, SlidersHorizontal, Bot, Edit3, FileDown, Upload];


const HowItWorks = () => {
const navigate = useNavigate();
  return (
    
    <div>
        
        {/* Header */}
      <AppHeader titleSize="text-5xl" />

      {/* Banner */}
      <section className="bg-accent from-indigo-100 via-purple-50 to-pink-100 py-20 px-4 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            <Settings className="inline-block mr-2 h-8 w-8 align-[-3px]" color="#101010" strokeWidth={2} aria-hidden="true" focusable="false" />
            How DeepToast Works
          </h1>
          <p className="text-lg md:text-xl text-gray-700 mb-8">
            Smart, fast, and AI-powered question creation designed for educators.
          </p>
          <a
            href="/DeepToast"
            className="bg-[#1b2b45] text-white px-7 py-4 rounded-full font-semibold hover:scale-108 hover:shadow-lg transition"
          >
            Start Generating
          </a>
        </div>
      </section>

    {/* Step Grid */}
    
    <section className="bg-secondary py-24 px-6 md:px-20">
    <div className="max-w-6xl mx-auto">

        <div className="flex flex-col md:flex-row md:flex-wrap md:justify-between gap-10">
        {steps.map((step, index) => {
          const IconComp = stepIcons[index] || Settings;
          return (
            <div
            key={index}
            className="relative md:w-[30%] bg-white border border-gray-200 rounded-2xl shadow-lg p-6 group hover:shadow-xl transition duration-300"
            >
            <div className="absolute -top-6 left-6 w-12 h-12 bg-accent text-primary font-bold text-xl flex items-center justify-center rounded-full shadow-md z-10">
                {index + 1}
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">
                <IconComp className="inline-block mr-2 h-6 w-6 align-[-2px]" color="#101010" strokeWidth={2} aria-hidden="true" focusable="false" />
                {step.title}
            </h3>
            <p className="text-gray-600 text-[16px]">{step.description}</p>
            </div>
        )})}
        </div>
    </div>
    </section>

    </div>
  );
};


export default HowItWorks;
